import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[usNumberFormat]',
})
export class PhoneNumberDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const trimmedValue = input.value.replace(/\D+/g, ''); // Remove all non-digit characters

    if (trimmedValue.length > 10) {
      input.value = trimmedValue.substring(0, 10); // Trim to 10 digits if more
    }

    // Format the input value as (xxx) xxx-xxxx
    const formattedValue = this.formatPhoneNumber(trimmedValue);
    input.value = formattedValue;
  }

  private formatPhoneNumber(value: string): string {
    if (value.length <= 3) {
      return value;
    } else if (value.length <= 6) {
      return `(${value.substring(0, 3)}) ${value.substring(3)}`;
    } else {
      return `(${value.substring(0, 3)}) ${value.substring(
        3,
        6
      )}-${value.substring(6)}`;
    }
  }
}
